import { useMutation } from "@tanstack/react-query";
import { deleteAssetFromSite, ignoreAssetFromSite, recoverAssetFromSite } from "../api/delete-asset-from-site";
export const useDeleteAssetFromSite = (projectId, queryParams = {}) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (assetId) => deleteAssetFromSite(projectId, assetId, queryParams),
        retry: false
    });
};
export const useIgnoreAssetFromSite = (projectId, queryParams = {}) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (assetId) => ignoreAssetFromSite(projectId, assetId, queryParams),
        retry: false
    });
};
export const useRecoverAssetFromSite = (projectId, queryParams = {}) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (assetId) => recoverAssetFromSite(projectId, assetId, queryParams),
        retry: false
    });
};
